exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-divider[data-v-cd6410d0]{height:0;margin:.5rem 0;overflow:hidden;border-top:1px solid #e9ecef}", ""]);

// exports
